/* @flow */

import Accordion from "./Accordion";

export type { ActiveMap } from "./types";
export default Accordion;
